/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { parseEDNString, toEDNString, toEDNStringFromSimpleObject } from 'edn-data';
import { List } from 'immutable';

export const ednRuleToImmutable = (query) => parseEDNString(query, { keywordAs: 'object' });

export const jsRuletoEdn = (queryObj) => toEDNString(queryObj);

// re-usable helper function to convert queuequery edn from JS and to edn:
export const convertQueueQueryFromJsToEdnString = (values) => {
  // update query level time format to minutes if selected time format is in 'minutes'
  const updatedValues = values.update('basicQuery', (levels) =>
    levels.map(
      (level) =>
        level.getIn(['selectedFilters', 'inQueueTimeFormat']) === 'minutes'
          ? level.updateIn(['map', 0, 1], (secondsInQueue) => secondsInQueue * 60).delete('selectedFilters')
          : level.delete('selectedFilters')
    )
  );
  const modifiedValues = updatedValues.update('basicQuery', (levels) =>
    levels.map((level) =>
      level.updateIn(['map', 1, 1, 'map'], (filters) =>
        filters.reduce((accumlator, lists) => {
          const filterKey = lists && lists.get(0);
          const updatedLists =
            lists &&
            lists.get(1) &&
            lists
              .get(1)
              .reduce((acc, list) => {
                const updatedListItem =
                  list &&
                  list.filter((listItem) => {
                    return filterKey.get('key') === 'skills'
                      ? listItem.getIn([1, 'map']).size !== 0
                      : listItem.getIn([1, 'set']).size !== 0;
                  });
                return acc.push(updatedListItem);
              }, List([]))
              .filter((a) => a.size !== 0);
          return updatedLists.size !== 0 ? accumlator.push(List([filterKey, updatedLists])) : accumlator;
        }, List([]))
      )
    )
  );
  // parse JS object to edn string
  const queryObj = modifiedValues.get('basicQuery').toJS();
  if (queryObj && queryObj[0].map[2]!==undefined && queryObj[0].map[2][0].key === 'sort' &&
    queryObj[0].map[2][1][0].list[0].map &&
    queryObj[0].map[2][1][0].list[0].map.length === 0) {
    delete(queryObj[0].map[2]);
  }

  const parsedQuery = jsRuletoEdn(queryObj);

  return values
    .set('query', parsedQuery)
    .delete('basicQuery')
    .toJS();
};
